import React from 'react'
import Subject from './Subject'
export default function Evs() {
  return (
    <div>
       <Subject title="Environmental Science(ASH402)" sub="EVS" syllabus="#"
    book1="NIL"
    book1Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}
